import React from "react";

export const BlueBox = (props: React.PropsWithChildren<any>) => {
  return <div className="blue-box">
    {props.children}
  </div>;
}